<template>
	<t-input-wrapper
		:label="label"
		:description="description"
		:hint="hint"
		:isInvalid="isInvalid"
		:validationMessage="validationMessage"
		:warningMessage="warningMessage"
	>
		<textarea
			ref="textarea"
			v-model="jsonString"
			:style="getStyle"
			:class="[{invalid: isInvalid, disabled: disabled}]"
			:placeholder="placeholder"
			:disabled="disabled"
			:aria-disabled="disabled"
			class="text-area"
			spellcheck="false"
			v-on="inputListeners"
			@keydown="onKeyDown"
		/>
	</t-input-wrapper>
</template>

<script>
import formMixin from './formMixin';
import inputWrapperMixin from './inputWrapperMixin';
import TInputWrapper from './TInputWrapper';
export default {
	name: 'TJsonTextArea',
	components: { TInputWrapper },
	mixins: [ formMixin, inputWrapperMixin ],
	props: {
		jsonObject: {
			type: Object,
			default: null
		},
		height: {
			type: String,
			default: '80px'
		},
		minHeight: {
			type: String,
			default: '80px'
		},
		maxHeight: {
			type: String,
			default: 'none',
		},
		resize: {
			type: String,
			default: 'both',
			validator: (value) => [ 'both', 'horizontal', 'vertical', 'none' ].indexOf(value) !== -1,
		},
		autoFocus: {
			type: Boolean,
			default: false
		},
	},
	data() {
		return { jsonString: null, };
	},
	computed: {
		getStyle() {
			return {
				width: this.width,
				paddingLeft: this.paddingLeft,
				resize: this.resize,
				height: this.height,
				minHeight: this.minHeight,
				maxHeight: this.maxHeight,
			};
		},
	},
	watch: {
		jsonObject: function() {
			this.setJsonString();
		}
	},
	mounted() {
		if (this.autoFocus) {
			document.activeElement.blur();
			this.$refs.textarea.focus();
		}
		this.setJsonString();
	},
	methods: {
		setJsonString() {
			if (this.jsonObject) {
				let jsonString = JSON.stringify(this.jsonObject, null, '\t');
				this.jsonString = jsonString;
			}
		},
		onKeyDown(event) {
			let specialKeys = ['Tab'];
			if (specialKeys.includes(event.code)) {
				event.stopPropagation();
				event.preventDefault();
				this[`on${event.code}`]();
			}
		},
		onTab() {
			let { textarea } = this.$refs;

			let start = textarea.selectionStart;
			let end = textarea.selectionEnd;

			let startText = this.jsonString.substr(0, start);
			let endText = this.jsonString.substr(end);
			this.jsonString = `${startText}\t${endText}`;

			this.$nextTick(() => {
				textarea.setSelectionRange(start+1, start+1);
			});

		}
	}
};
</script>

<style lang="scss" scoped>
@import './scss/form';
</style>


<docs>
## Examples
```jsx noeditor
new Vue({
	data(){
		return {
			jsonObject: {
				foo:{
					bar: 1
				},
				baz: 'Allows using tab (\t) in textarea'
			},
		}
	},
	template: `
		<div style="width:100%;">
			<t-json-text-area
				height="150px"
				:jsonObject="jsonObject"
			/>
		</div>
	`
});
```

```html
<t-json-text-area
	:jsonObject="jsonObject"
/>
```
</docs>
